export default __webpack_public_path__ + "static/media/filter-avisos-mantencion.432bc6c0.svg";